<template>
  <p class="SupportMessage">
    {{ content.preText }}
    <a :href="content.linkUrl">{{ content.linkText }}</a>
  </p>
</template>

<script>
export default {
  props: {
    content: {
      type: Object,
    },
  },
}
</script>

<style scoped>

.SupportMessage {
  font-weight: 500;
  font-size: var(--font-size-2);
  color: var(--text-color-black);
}

.SupportMessage a {
  color: var(--brand-color);
  transition: filter 0.15s;
}

.SupportMessage a:hover {
  filter: brightness(0.85);
}
</style>
